module.exports = __webpack_public_path__ + "img/activity_nav_dark.e8642bd9.svg";